/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkillSuggestion
 */
export interface SkillSuggestion {
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestion
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof SkillSuggestion
     */
    type: SkillSuggestionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof SkillSuggestion
     */
    score: number;
}


/**
 * @export
 */
export const SkillSuggestionTypeEnum = {
    Global: 'GLOBAL',
    Functional: 'FUNCTIONAL'
} as const;
export type SkillSuggestionTypeEnum = typeof SkillSuggestionTypeEnum[keyof typeof SkillSuggestionTypeEnum];


/**
 * Check if a given object implements the SkillSuggestion interface.
 */
export function instanceOfSkillSuggestion(value: object): value is SkillSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function SkillSuggestionFromJSON(json: any): SkillSuggestion {
    return SkillSuggestionFromJSONTyped(json, false);
}

export function SkillSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'type': json['type'],
        'score': json['score'],
    };
}

export function SkillSuggestionToJSON(value?: SkillSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'type': value['type'],
        'score': value['score'],
    };
}

